import { Row } from '../../../../coaching-observation/experimental.grid';

import { CellContext, RowContext } from './commitment-narrative.model';
import { FilterOptions } from './models/filter-options';

export interface State {
    pending: {
        reload?: boolean;
    };
    rows?: Array<Row<RowContext, CellContext>>;
    filteredRow?: Array<Row<RowContext, CellContext>>;

    filterCreators?: string[];
    filterUpdaters?: string[];
    filterOpts?: FilterOptions;
    focusNoteId?: string;
}

export const defaultState = (): State => ({
    pending: {},
    rows: [],
    filteredRow: [],
});
